import { FormGroup, InputAdornment, TextField } from "@mui/material";
import React from "react";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import ApartmentIcon from "@mui/icons-material/Apartment";
import SignpostIcon from "@mui/icons-material/Signpost";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import LanguageIcon from "@mui/icons-material/Language";
import BadgeIcon from "@mui/icons-material/Badge";
import { t } from "i18next";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";

const FormStudio = ({ formData, onChangeInput, onResetColor }) => {
  return (
    <div className="flex flex-col w-4/5">
      <FormGroup className="w-full">
        <CoreInputField
          label={t("Name")}
          type="text"
          name="name"
          onChange={onChangeInput}
          value={formData.name}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <ApartmentIcon className="text-gray" />
              </InputAdornment>
            ),
          }}
        />
      </FormGroup>
      <FormGroup className="w-full">
        <CoreInputField
          label={t("Address")}
          type="text"
          name="address"
          onChange={onChangeInput}
          value={formData.address}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SignpostIcon className="text-gray" />
              </InputAdornment>
            ),
          }}
        />
      </FormGroup>
      <FormGroup className="w-full">
        <CoreInputField
          label="Email"
          type="email"
          name="email"
          onChange={onChangeInput}
          value={formData.email}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailIcon className="text-gray" />
              </InputAdornment>
            ),
          }}
        />
      </FormGroup>
      <FormGroup className="w-full">
        <CoreInputField
          name="phoneNumber"
          label={t("Phone")}
          value={formData.phoneNumber}
          onChange={onChangeInput}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PhoneIphoneIcon className="text-gray" />
              </InputAdornment>
            ),
          }}
        />
      </FormGroup>
      <FormGroup className="w-full">
        <CoreInputField
          name="website"
          label={t("Website")}
          value={formData.website}
          onChange={onChangeInput}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LanguageIcon className="text-gray" />
              </InputAdornment>
            ),
          }}
        />
      </FormGroup>

      <FormGroup className="w-full">
        <CoreInputField
          name="vat"
          label={t("VAT")}
          value={formData.vat}
          onChange={onChangeInput}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <BadgeIcon className="text-gray" />
              </InputAdornment>
            ),
          }}
        />
      </FormGroup>
      <FormGroup className="w-full">
        <TextField
          className="mt-8"
          label={t("Description")}
          name="description"
          multiline
          rows={5}
          value={formData.description}
          onChange={onChangeInput}
          focused
          color="grey"
        />
      </FormGroup>

      <div className="flex flex-col">
        <h3 className="font-bold ">{t("YourColors")}</h3>
        <p className="m-0">{t("EditYourColors")}</p>
        <div className="flex w-full space-x-4 ">
          <CoreInputField
            className="w-full"
            name="primaryColor"
            label={t("PrimaryColor")}
            type="color"
            value={formData.primaryColor || "#ffffff"}
            onChange={onChangeInput}
            focused
            color="grey"
          />

          <CoreInputField
            className="w-full"
            name="secondaryColor"
            label={t("SecondaryColor")}
            type="color"
            value={formData.secondaryColor || "#ffffff"}
            onChange={onChangeInput}
            focused
            color="grey"
          />
        </div>
        <div className="text-start mt-4">
          <CoreButton
            testo="reset"
            className="btn-round-outline"
            onClick={onResetColor}
          />
        </div>
      </div>
    </div>
  );
};

export default FormStudio;
